import { Actions, ButtonLink, IconRenderer } from 'braid-design-system';

import file from './TestStepsWorkbook.xlsx';
import { MicrosoftExcelLogoIcon } from '@phosphor-icons/react';

export const TestStepsWorkbook = () => (
  <Actions>
    <ButtonLink
      download="2025 Apply with SEEK revision - Test Steps.xlsx"
      href={file}
      icon={
        <IconRenderer>
          {({ className }) => <MicrosoftExcelLogoIcon className={className} />}
        </IconRenderer>
      }
      variant="soft"
    >
      Test Steps Workbook
    </ButtonLink>
  </Actions>
);
